import type { ImageDetails } from "proto/image"
import type { Address } from "proto/address"
import type { CartItem } from "./food-menu"
import type { User } from "proto/user"
import type { Vertical } from "$lib/def/verticals"
import type { Totals } from "proto/order"

export interface Item {
	section_id: number
	item_id: number
	variant_id: number
	quantity: number
	item_name: string
	variant_name: string
	item_price: number
	extras_total: number
	addons_total: number
	base_price: number
	price: number
	old_price: number
	menu_deal_action: string
	maximum_select: number
	collect_only: boolean
	addons: Addons[]
	extras: Choices[];
	options: Choices[];
}

export interface Cart {
	cart_type: string
	uuid: string
	customer: {
		id: number
		name: string
		address: Partial<Address>
	}
	type: string
	order_notes: string
	created_at_ts: number
	updated_at_ts: number
	cart_ttl_seconds: number
	collect_time_mins: number
	deliver_time_mins: number
	status: string
	can_check_out: boolean
	check_out_error: string
	menu_id: number
	restaurant: {
		id: number
		name: string
		suburb: string
		delivery_fee: number
		min_order_value: number
		ignore_min_order_rules: boolean
		restaurant_group_id: number
		primary_food_tag: string
		logo: {
			base_url: string
			filename: string
		}
	}
	items: Item[];
	totals: Totals,
	promotion: {
		promotion_definition_uuid: string
		cart_line_title: string
		condition_failed: boolean
	}
}

export interface Choice {
	id: number;
	name: string;
	group_id: number;
	price: number;
	quantity: number;
}

export interface Choices {
	id: number;
	name: string;
	description: string;
	items: Choice[];
	total: number;
	minimum_select: number;
	maximum_select: number;
}

export interface Addon extends Choice {
	delta_price: number
	variant_id: number
	options: Choices[];
	extras: Choices[];
	extras_total: number
}

export interface Addons extends Choices {
	items: Addon[];
	price_rule: string
}

export interface CartHeader {
	vertical: Vertical;
	restaurantId: number;
	id: string;
	address: Address;
	menuId: number;
	itemCount: number;
	lastUpdated: number;
	expiresAt: number;
	checked_out?: boolean;
}

export enum DeliveryOption {
	Delivery = 'delivery',
	Collect = 'collect',
}

export interface ItemAndMenu {
	item?: Partial<CartItem>,
	menu_id: number,
	restaurant_id: number,

	/**
	 * If this is set, we are editing an existing item in the cart
	 */
	editIndex?: number;
}

export interface patchDelivery {
	uuid?: string,
	type?: DeliveryOption,
	order_notes?: string,
}

export interface Customer extends User {
	address: Address;
}
